import { createSlice } from '@reduxjs/toolkit'

export const connectionPointSlice = createSlice({
    name: 'connectionPoints',
    initialState: [],
    reducers: {
        addConnectionPoint: (state, action) => {
            return [...state, action.payload]
        },
        addAllConnectionPoints: (state, action) => {
            return action.payload || [...state]
        },
        deleteConnectionPoint: (state, action) => {
            return state.filter((connectionPoint) => connectionPoint.id !== action.payload.id)
        },
        resetConnectionPoint: (state, action) => {
            return []
        }
    }
})

export const { addConnectionPoint, deleteConnectionPoint, resetConnectionPoint, addAllConnectionPoints } = connectionPointSlice.actions
export default connectionPointSlice.reducer
